import styled from "styled-components";
import { Text } from "components/Text";

export const Domain = styled(Text.Heading4)`
  font-weight: 600;
  margin: 16px 0;
  color: ${({ theme }) => theme.color.additional.dark.value};
`;
